import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { RiAdminFill } from "react-icons/ri";
import { SiGoogleanalytics } from "react-icons/si";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { IoDocumentText } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';

const Navbar = ({ currentPage, setAirportPickupData, formLink }) => {
    const username = localStorage.getItem("currentuser") ?? 'Hello'; 
    const navigate = useNavigate();

    function handleLogout() {
        navigate('/adminLogin');
        localStorage.removeItem("currentuser");
    }

    const pickupFormLink = formLink || "/f/bnVyc2luZy9DT0VGb3JtL2xhbmd1YWdl";

    return (
        <div>
            {(currentPage === 'AdminPortal' || currentPage === 'Statistic') && (
        <div className="navbar">
            <div className="navbar-header">
                {username && <p>Welcome, {username}</p>}
            </div>
            <div className="navbar-content">
                <Link to="/adminPortal">
                    <button type="button" className="nav-button">
                        <RiAdminFill style={{ color: 'white', marginRight: '6px', fontSize: '18px' }} />
                        <span>Admin Portal</span>
                    </button>
                </Link>
                      

            </div>
            <div className="navbar-footer">
                <button type="button" className="logout-button" onClick={() => handleLogout()}>
                    <span>Logout</span>
                    <RiLogoutBoxRLine style={{ color: 'white', marginLeft: '6px', fontSize: '18px' }} />
                </button>
            </div>
                </div>
            )}

            {currentPage === 'PickupForm' && (
                <div className="navbar">     
                    <div className="navbar-header"/>
                    <div className="navbar-content">                   
                        <Link to={pickupFormLink}>
                            <button type="button" className="nav-button">
                                <IoDocumentText style={{ color: 'white', marginRight: '6px', fontSize: '18px' }} />
                                <span>Form</span>
                            </button>
                        </Link>
                    </div>
                    <div className="navbar-footer"/>                 
                </div>
            )}


        </div>
    );
}

export default Navbar;
